import axios from 'axios';
import { browserHistory } from 'react-router';
import { SubmissionError } from 'redux-form';
import { toFromDates } from '../components/Common/cleanDates';

import {
  REQUEST_PREVIOUSSOS,
  FETCH_PREVIOUSSOS_SUCCESS,
  FETCH_PREVIOUSSOS_FAILURE,
  REQUEST_PREVIOUSORDERS,
  REQUEST_PREVIOUSSO_DETAIL,
  FETCH_PREVIOUSSO_DETAIL_SUCCESS,
  FETCH_PREVIOUSSO_DETAIL_FAILURE,
  FETCH_PREVIOUSORDERS_SUCCESS,
  FETCH_PREVIOUSORDERS_FAILURE,
  SELECT_PREVIOUSORDERS,
  RESET_CURRENT_PREVIOUSORDERS,
  REQUEST_PREVIOUSORDERS_DETAIL,
  FETCH_PREVIOUSORDERS_DETAIL_SUCCESS,
  FETCH_PREVIOUSORDERS_DETAIL_FAILURE,
  REQUEST_ADDING_PREVIOUSORDER,
  ADD_PREVIOUSORDER_SUCCESS,
  ADD_PREVIOUSORDER_FAILURE,
  REQUEST_DELETE_PREVIOUSORDER,
  DELETE_PREVIOUSORDER_SUCCESS,
  DELETE_PREVIOUSORDER_FAILURE,
} from '../actions/type';

import { PREVIOUSORDERS_URL, SALES_ORDERS_URL } from './url';

import { DEFAULT_ERROR } from '../components/Common/constants';
// Inventories Actions

export function fetchPreviousOrdersSuccess(previousOrders) {
  return {
    type: FETCH_PREVIOUSORDERS_SUCCESS,
    payload: previousOrders,
  };
}

export function fetchPreviousOrdersFailure(error) {
  return {
    type: FETCH_PREVIOUSORDERS_FAILURE,
    payload: error,
  };
}

export function fetchPreviousOrders(customerID, fromDate, toDate) {
  return (dispatch) => {
    dispatch({ type: REQUEST_PREVIOUSORDERS });
    const dates = toFromDates(-1, fromDate, toDate);
    return axios.get(
      PREVIOUSORDERS_URL + customerID + '?StartDate=' + dates.fromDate + '&EndDate=' + dates.toDate,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchPreviousOrdersSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchPreviousOrdersFailure(err));
      });
  };
}

// Fetch previous sales order
export function fetchPreviousSOsSuccess(previousSOs) {
  return {
    type: FETCH_PREVIOUSSOS_SUCCESS,
    payload: previousSOs,
  };
}

export function fetchPreviousSOsFailure(error) {
  return {
    type: FETCH_PREVIOUSSOS_FAILURE,
    payload: error,
  };
}
export function fetchPreviousSalesOrderByCustomer(customerId, postingDateGT, postingDateLT) {
  return (dispatch) => {
    dispatch({ type: REQUEST_PREVIOUSSOS });
    // default 90 days
    const days = 90;
    const dates = toFromDates(days, postingDateGT, postingDateLT);
    return axios.get(
      `${SALES_ORDERS_URL}search/?Deliver_Customer_id=${customerId}&OrderDate__gte=${dates.fromDate}&OrderDate__lte=${dates.toDate}`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchPreviousSOsSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchPreviousSOsFailure(err));
      });
  };
}

export function fetchSalesOrderDetailSuccess(salesOrderDetail) {
  return {
    type: FETCH_PREVIOUSSO_DETAIL_SUCCESS,
    payload: salesOrderDetail,
  };
}

export function fetchSalesOrderDetailFailure(error) {
  return {
    type: FETCH_PREVIOUSSO_DETAIL_FAILURE,
    payload: error,
  };
}

// Fetch products from all previous sales order
export function fetchPreviousOrdersFromALLSOsSuccess(products) {
  return {
    type: FETCH_PREVIOUSSO_DETAIL_SUCCESS,
    payload: products,
  };
}
export function fetchPreviousOrdersFromALLSOsFailure(error) {
  return {
    type: FETCH_PREVIOUSSO_DETAIL_FAILURE,
    payload: error,
  };
}
export function fetchPreviousOrdersFromALLSalesOrder(customerId, postingDateGT, postingDateLT) {
  return (dispatch) => {
    dispatch({ type: REQUEST_PREVIOUSSO_DETAIL });
    // default 90 days
    const days = 90;
    const dates = toFromDates(days, postingDateGT, postingDateLT);
    return axios.get(
      `${SALES_ORDERS_URL}previous_date?Deliver_Customer_id=${customerId}&OrderDate__gte=${dates.fromDate}&OrderDate__lte=${dates.toDate}`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchPreviousOrdersFromALLSOsSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchPreviousOrdersFromALLSOsFailure(err));
      });
  };
}

// Fetch SO from select search
export function fetchPreviousOrderBySearchSuccess(salesOrderDetail) {
  return {
    type: FETCH_PREVIOUSSO_DETAIL_SUCCESS,
    payload: salesOrderDetail,
  };
}
export function ffetchPreviousOrderBySearchFailure(error) {
  return {
    type: FETCH_PREVIOUSSO_DETAIL_FAILURE,
    payload: error,
  };
}
export function fetchPreviousOrderBySearch(SONum) {
  return (dispatch) => {
    dispatch({ type: REQUEST_PREVIOUSSO_DETAIL });
    return axios.get(
      `${SALES_ORDERS_URL}?SONum=${SONum}`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchPreviousOrderBySearchSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(ffetchPreviousOrderBySearchFailure(err));
      });
  };
}

// Fetch products from select sales order
export function fetchPreviousOrderById(salesOrder_id) {
  return (dispatch) => {
    dispatch({ type: REQUEST_PREVIOUSSO_DETAIL });
    return axios.get(
      `${SALES_ORDERS_URL}?pk=${salesOrder_id}`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchSalesOrderDetailSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchSalesOrderDetailFailure(err));
      });
  };
}

export function fetchPreviousSalesOrderByIndexFromLast(customerId, indexFromLast) {
  return (dispatch) => {
    dispatch({ type: REQUEST_PREVIOUSORDERS });
    return axios({
      method: 'GET',
      url: `${PREVIOUSORDERS_URL}${customerId}/${indexFromLast}`,
      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
    }).then((response) => {
      dispatch(fetchPreviousOrdersSuccess(response));
    }, (err) => {
      if (err.status === 500 || err.status === 404) {
        err.data = DEFAULT_ERROR;
      }
      dispatch(fetchPreviousOrdersFailure(err));
    });
  };
}

export function selectPreviousOrders(previousOrders) {
    return {
        type: SELECT_PREVIOUSORDERS,
        payload: previousOrders
    };
}

export function resetCurrentPreviousOrders() {
    return {
        type: RESET_CURRENT_PREVIOUSORDERS
    }
}


export function fetchPreviousOrdersDetail(previousOrders_id) {
    return dispatch => {
        dispatch({ type: REQUEST_PREVIOUSORDERS_DETAIL });
        return axios.get(PREVIOUSORDERS_URL + previousOrders_id,
            {
                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
            })
            .then(response => {
              dispatch(fetchPreviousOrdersDetailSuccess(response));
            }, err => {
              if (err.status === 500 || err.status === 404) {
                err.data = DEFAULT_ERROR;
              }
              dispatch(fetchPreviousOrdersDetailFailure(err));
            });
    }
}

export function fetchPreviousOrdersDetailSuccess(previousOrdersDetail) {
    return {
        type: FETCH_PREVIOUSORDERS_DETAIL_SUCCESS,
        payload: previousOrdersDetail
    };
}

export function fetchPreviousOrdersDetailFailure(error) {
    return {
        type: FETCH_PREVIOUSORDERS_DETAIL_FAILURE,
        payload: error
    };
}

export function addNewPreviousOrder({
    Product_id,
    ProductNum,
    RefNum,
    ProductName,
    PreSale,
    InStock,
    Ordered,
    Price
}) {
  return dispatch => {
      dispatch({ type: REQUEST_ADDING_PREVIOUSORDER });
      axios.post(PREVIOUSORDERS_URL,
          {
              Product_id,
              ProductNum,
              RefNum,
              ProductName,
              PreSale,
              InStock,
              Ordered,
              Price
          },
          {
              headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
          }
      )
          .then(response => {
            dispatch(addPreviousOrderSuccess());
          }, err => {
            if (err.status === 500 || err.status === 404) {
              err.data = DEFAULT_ERROR;
            }
            dispatch(addPreviousOrderFailure(err));
          });
  }
}

export function addPreviousOrderSuccess() {
    return {
      type: ADD_PREVIOUSORDER_SUCCESS,
    }
}

export function addPreviousOrderFailure(response) {
    return {
      type: ADD_PREVIOUSORDER_FAILURE,
      payload: response
    }
}

export function deletePreviousOrder(Product_id) {
  return dispatch => {
      dispatch({ type: REQUEST_DELETE_PREVIOUSORDER });
      axios.delete(PREVIOUSORDERS_URL + Product_id,
        {
          headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
        }
      )
      .then(response => {
        dispatch(deletePreviousOrderSuccess());
      }, err => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(deletePreviousOrderFailure());
      });
  }
}

export function deletePreviousOrderSuccess() {
    return {
      type: DELETE_PREVIOUSORDER_SUCCESS,
    }
}

export function deletePreviousOrderFailure(response) {
    return {
      type: DELETE_PREVIOUSORDER_FAILURE,
      payload: response
    }
}



// WEBPACK FOOTER //
// ./master/jsx/actions/previousOrders_actions.jsx